<div class="flex justify-content-between align-items-center pb-3 border-bottom-1 border-bluegray-300">
  <div class="font-semibold text-2xl" data-clarity-unmask="true">{{ mode === 'validTo' ? 'Zmień datę ważności' : 'Przydziel abonament' }}</div>
  <button class="secondary-button p-0" (click)="closeDialog()" data-clarity-unmask="true">X</button>
</div>

<div class="mt-3 text-sm text-bluegray-500">
  Użytkownik: <span class="font-semibold text-color">{{ user.displayName }}</span>
  <span *ngIf="user.email"> ({{ user.email }})</span>
</div>

<div class="flex flex-column gap-4 mt-4">
  <div *ngIf="mode === 'assign'" class="flex flex-column gap-2">
    <label for="subscriptionPlan" class="text-gray-500 text-sm">Abonament</label>
    <p-dropdown
      inputId="subscriptionPlan"
      [options]="plans"
      [(ngModel)]="selectedPlan"
      (onChange)="onPlanSelected()"
      [loading]="plansLoading"
      optionLabel="planName"
      placeholder="Wybierz abonament"
      appendTo="body"
      styleClass="w-full"
    >
      <ng-template pTemplate="selectedItem" let-plan>
        {{ plan.planName }} ({{ plan.value }} {{ plan.currency }})
      </ng-template>
      <ng-template pTemplate="item" let-plan>
        {{ plan.planName }} ({{ plan.value }} {{ plan.currency }})
      </ng-template>
    </p-dropdown>
  </div>

  <div *ngIf="mode === 'validTo'" class="flex flex-column gap-2">
    <span class="text-gray-500 text-sm">Abonament</span>
    <span class="font-semibold">Pakiet {{ planName }}</span>
  </div>

  <div class="flex flex-column gap-2">
    <label for="validTo" class="text-gray-500 text-sm">Aktywny do</label>
    <p-calendar
      inputId="validTo"
      [(ngModel)]="validTo"
      [showIcon]="true"
      [showOnFocus]="false"
      dateFormat="dd.mm.yy"
      appendTo="body"
      [minDate]="mode === 'assign' ? minimumDate : null"
      placeholder="Wybierz datę"
    />
    <small class="text-bluegray-400">Abonament będzie aktywny do końca wybranego dnia.</small>
    <small *ngIf="mode === 'validTo' && validToInPast" class="text-orange-600">
      Wybrana data już minęła — abonament wygaśnie od razu po zapisaniu.
    </small>
  </div>
</div>

<div class="flex pt-5 justify-content-end gap-2">
  <p-button class="link-btn" label="Anuluj" [link]="true" (onClick)="closeDialog()" data-clarity-unmask="true" />
  <p-button
    [disabled]="(mode === 'assign' && !selectedPlan) || !validTo || isSaving"
    [loading]="isSaving"
    icon="pi pi-save"
    label="Zapisz"
    (onClick)="save()"
    data-clarity-unmask="true"
  />
</div>
